import * as actionTypes from './actionTypes';
import * as linearCalendarTypes from '../linearCalendar/actionTypes';

export const filterPayload = {
  activityTypes: [],
  activityName: null,
  activityAttributes: [],
  stationCodes: [],
  activityDateRange: {
    startInclusive: null,
    endInclusive: null,
  },
  creditRange: {
    startInclusive: null,
    endInclusive: null,
  },
  includeTotalEntries: true, // fixed
  firstResult: 0, // comes from pagination
  maxResults: 10, // comes from pagination
  sortCriteria: 'START_DATE', // comes from Open Time Search
  sortDirection: 'ASCENDING', // comes from Open Time Search
};

const initialState = {
  bidAnalyzer: {},
  results: {},
  stations: {},
  error: { activityError: false, message: '' },
  isFetching: false,
  filter: { ...filterPayload },
  actionType: {}
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_OPEN_TIME_ACTIVITIES_REQUEST: {
      let filter = { ...state.filter };
      if (action.persistFilter) {
        filter = { ...action.filterPayload };
      }
      return { ...state, filter, bidAnalyzer: {}, results: {}, isFetching: true, actionType: action.type };
    }
    case actionTypes.FETCH_OPEN_TIME_ACTIVITIES_SUCCESS: {
      const { layover, ...results } = action;
      return { ...state, results, stations: { layover }, isFetching: false, actionType: action.type };
    }
    case actionTypes.FETCH_OPEN_TIME_ACTIVITIES_FAILURE:
      return { ...state, error: { activity: true, messages: action.messages }, isFetching: false, actionType: action.type };
    case actionTypes.FETCH_BID_ANALYZER_REQUEST:
      return { ...state, bidAnalyzer: { isFetching: true }, actionType: action.type };
    case actionTypes.FETCH_BID_ANALYZER_SUCCESS:
      return { ...state, bidAnalyzer: { ...action, isFetching: false }, actionType: action.type };
    case actionTypes.FETCH_BID_ANALYZER_FAILURE:
      return { ...state, bidAnalyzer: { isFetching: false, analysis: { error: action.error } }, actionType: action.type };
    case actionTypes.UPDATE_OPEN_CONFIG_PAYLOAD: {
      const paginationconfig = { ...state.openTimeSearchConfig, ...action.payload };
      return { ...state, openTimeSearchConfig: paginationconfig, actionType: action.type };
    }
    case actionTypes.CLEAR_FILTER_PAYLOAD: {
      return { ...state, filter: { ...initialState.filter }, actionType: action.type };
    }
    case linearCalendarTypes.UPDATE_CALENDAR_ACTIVITIES: {
      return { ...state, actionType: action.type };
    }
    case actionTypes.ADD_OPEN_TIME_REQUEST_SUCCESS: {
      return { ...state, actionType: action.type };
    }
    case actionTypes.ADD_OPEN_TIME_REQUEST_FAILURE: {
      return { ...state, actionType: action.type };
    }
    default:
      return { ...state, actionType: '' };
  }
};

export { reducer as default };
